import { useCallback, useEffect, useState } from "react";
import { RefreshCw, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const HitsMonitor = () => {
  const [hits, setHits] = useState([]);
  const load = useCallback(() => api.get("/hits").then((r) => setHits(r.data)), []);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);

  return (
    <section className="panel-card" data-testid="hits-monitor">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Smartphone className="w-4 h-4 text-[#10B981]" />
          <h2 className="font-heading text-base md:text-lg font-semibold">Requisições recebidas do celular</h2>
        </div>
        <Button variant="outline" size="icon" className="btn-ghost h-10 w-10" onClick={load} data-testid="hits-refresh-button"><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <p className="text-xs text-[#9CA3AF] mt-2">Mande uma mensagem de outro número para o seu WhatsApp. Se nada aparecer aqui, o Auto Reply não está chamando esta URL.</p>
      {hits.length === 0
        ? <p className="text-sm text-amber-300 mt-4" data-testid="hits-empty">Nenhuma requisição recebida ainda.</p>
        : (
          <ul className="mt-4 space-y-2" data-testid="hits-list">
            {hits.map((h, i) => (
              <li key={i} className="log-item" data-testid={`hit-item-${i}`}>
                <div className="flex flex-wrap items-center gap-2 text-xs font-mono">
                  <span className={`mono-badge ${h.valid ? "badge-ai" : "badge-error"}`}>{h.method} {h.valid ? "OK" : "URL inválida"}</span>
                  <span className="text-[#6B7280]">{new Date(h.created_at).toLocaleString("pt-BR")}</span>
                </div>
                <code className="block mt-2 text-[11px] text-[#9CA3AF] break-all">{h.body || h.query || "(sem conteúdo)"}</code>
              </li>
            ))}
          </ul>
        )}
    </section>
  );
};
